var _defs, _circle, _path, _path2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreparing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_961",
    width: 44.319,
    height: 44.319,
    viewBox: "0 0 44.319 44.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2,.cls-4{fill:none}.cls-2{stroke:#000}.cls-3{stroke:none}\r\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    cx: 22.16,
    cy: 22.16,
    r: 22.16,
    fill: "#d5d5d5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    d: "M5568.008-11981.249H5554v7.407",
    className: "cls-2",
    transform: "translate(-5533.351 12003.677)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    d: "M5535.479-12000.9a7.373 7.373 0 0 1 6.55 3.109c2.356 3.553 5.171 4.686 9.607 4.753.056-.014 2.994 0 2.994 0",
    className: "cls-2",
    transform: "translate(-5521.348 12015.076)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    className: "cls-2",
    transform: "translate(9.849 13.542)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.309,
    cy: 4.309,
    r: 4.309,
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.309,
    cy: 4.309,
    r: 3.809,
    className: "cls-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64",
    className: "cls-2",
    transform: "translate(12.311 16.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.847,
    cy: 1.847,
    r: 1.847,
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.847,
    cy: 1.847,
    r: 1.347,
    className: "cls-4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparing);
export default __webpack_public_path__ + "static/media/preparing.6079b4767a05de8722740d099ccc2df4.svg";
export { ForwardRef as ReactComponent };